import { Card, Row } from 'antd';
import React from 'react';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';

const AdditionalInfoCard = () => {
  return (
   
        
        <Card title={<GetLabel label="AdditionalInfo" style={{fontWeight:'bold',paddingLeft:15}} />}>
          <Row gutter={32}>
            <FormInput col xs={12} name="tpfree1" />
            <FormInput col xs={12} name="tpfree2" />
            <FormInput col xs={12} name="tpfree3" />
            <FormInput col xs={12} name="tpfree4" />
            <FormInput col xs={12} name="tpfree5" />
          </Row>
        </Card>
    
   
  );
};

export default AdditionalInfoCard;
